// axiosInstance.js
import axios from 'axios';
import { b2b_server_api, baseURL, server_API } from './config';

const axiosInstance = axios.create({
  baseURL: server_API,
  withCredentials: true,
});


const removeAccessToken = () => {
  axios.post(`${server_API}/v2/user/logout`, {}, { withCredentials: true }).then((response) => {
    console.log(response);
    window.location.href = `${baseURL}#/login`;
  })
    .catch((error) => {
      console.log(error);
    });


};


axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;


    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {

        await axios.post(`${server_API}/v2/user/refresh`, {}, { withCredentials: true });
        return axiosInstance(originalRequest);
      } catch (err) {
        console.error('Token refresh failed. Redirecting to login.');
        removeAccessToken();
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
export { removeAccessToken };
